(function ($) {
  'use strict'

  Drupal.behaviors.megamenuPromoWrapper = {
    attach: function (context) {

      const promos = $('.field-megamenu-promo-block', context);

      promos.each(function() {
        const url = $(this).find('a').attr('href');
        if (url) {
          let target = '';
          if (url.indexOf('::')) {
            target = '_blank';
          }

          $(this).wrap('<a class="link-wrap" target="' + target + '" href="' + url + '" />');
        }
      });
    }
  }
}) (jQuery)
